import React from 'react';

import './painel-cards.css'


export const PainelCards: React.FC = (props) => {
  return <ul className="row painel-cards">{props.children}</ul>
}

export const ItemPainel: React.FC = (props) => {
  return <li className="col-xs-12 col-sm-6 col-md-4">{props.children}</li>
}
